import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

export const StyledInput = styled(TextField)(({ theme }) => ({
  width: '100%',

  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.contrastText,
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.contrastText,
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.contrastText,
    },
  },

  '& .MuiInputBase-input': {
    padding: theme.spacing(1.5, 2),
    fontSize: '1.25rem',
    border: '1px solid',
    borderColor: theme.palette.primary.contrastText,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transition: 'all 0.2s',
  },
}));
